import axiosInstance from "../../../../axiosInstance";
import { success, error, info } from "../../../../store/notification/actions";

export async function SendSupportMail(data) {
    try {
        if(data != null) {
            info("Raising Support Ticket ...");
            const response = await axiosInstance.post("/email/sendSupportEmail", {
                user_email: data.user_email,
                email_content: data.email_content,
                ticket_number : data.ticket_number
            });
            if (response) {
                success("Support Ticket Created successfully");
                return true;
            } else {
                error("Error sending email !!!");
                return false;
            }
        }
    } catch (err) {
      error("Error sending email !!!");
    }
  }


  export async function GetUserEmail(user_id) {
    try {
        if(user_id != null) {
            // info("Fetching User email ...");
            const response = await axiosInstance.post("/email/getUserEmail", {
                user_id: user_id,
            });
            if (response) {
                // success("Fetched User email successfully");
                if (response.data.data && response.data.data.length > 0) {
                    return response.data.data;
                  } else {
                    return [];
                  }
            } else {
                error("Error fetching email !!!");
            }
        }
    } catch (err) {
        error(err.response.data.error[0].message);
    }
  }  